import { useEffect, useState } from "react";
import { authApi } from "../api/auth";

interface AuthStatus {
    isLoggedIn: boolean;
    userId: number | null;
    loading: boolean;
}

export const useAuthStatus = (): AuthStatus => {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
    const [userId, setUserId] = useState<number | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // Fast path: check window.pgUserId injected by WordPress for logged-in users
        if (window.pgUserId) {
            setIsLoggedIn(true);
            setUserId(window.pgUserId);
            setLoading(false);
            return;
        }

        // Fallback: call auth-status endpoint (for non-logged-in or uncertain state)
        const checkAuth = async () => {
            try {
                const response = await authApi.checkAuthStatus();
                if (response.data.logged_in) {
                    setIsLoggedIn(true);
                    setUserId(response.data.user_id);
                } else {
                    setIsLoggedIn(false);
                    setUserId(null);
                }
            } catch {
                setIsLoggedIn(false);
                setUserId(null);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    return { isLoggedIn, userId, loading };
};
